import React from "react";
import {ListGroup} from "react-bootstrap";
import {Link, useRouteMatch} from "react-router-dom";
import Flex from "../../../components/common/Flex";
import {useSelector} from "react-redux";
import {selectLang, Translate} from "../../../app/store/reducers/main/mainReducer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Dashboard = () => {
    const {url} = useRouteMatch();
    const lang = useSelector(selectLang);
    const t = Translate;

    return (
        <ListGroup>
            <a href={'https://edi.hippo.uz'} target={'_blank'} className={'text-decoration-none'}>
                <ListGroup.Item className='p-3 p-sm-4' action>
                    <Flex alignItems="center" className={'gap-3'}>
                        <h5 className="mb-1">{t(lang, 'edi.navbar.edi-hippo')}</h5>
                        <FontAwesomeIcon size={'sm'} icon={'up-right-from-square'}/>
                    </Flex>
                    <p className="mb-1">
                        {t(lang, 'edi.navbar.routes.edi-hippo.description')}
                    </p>
                </ListGroup.Item>
            </a>

            <ListGroup.Item className='p-3 p-sm-4' as={Link} to={`${url}/contracts-formation`} action>
            <Flex justifyContent="between">
                <h5 className="mb-1">{t(lang, 'edi.navbar.routes.contract_formation')}</h5>
                </Flex>
                <p className="mb-1">
                    {t(lang, 'edi.navbar.routes.contract_formation.description')}
                </p>
            </ListGroup.Item>
        </ListGroup>
    )
};

export default Dashboard;